module.exports = __webpack_public_path__ + "static/img/btn2.82f96ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/5/btn2.png
// module id = P5r3
// module chunks = 0